import { useEffect, useRef } from 'react';

/**
 * Store previous state value for later comparison.
 * @param {any} value
 */
export const usePrevious = <T>(value: T) => {
    const ref = useRef<T>();

    useEffect(() => {
        ref.current = value;
    });

    return ref.current;
};
